import { TermDto } from '@act/shared/data-transfer-objects';
import { Box } from '@mui/material';

import ConsentTermCopy from './ConsentTermCopy';

interface ConsentTermContentProps {
  term: TermDto;
}

const ConsentTermContent = ({ term }: ConsentTermContentProps) => {
  if (!term) {
    return <Box>Loading content...</Box>;
  }

  return (
    <Box sx={{ maxWidth: '100%' }}>
      <ConsentTermCopy copy={term.text} />
    </Box>
  );
};

export default ConsentTermContent;
